import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import GridLoading from '../../../../components/grid-loading';
import baseColumns from './archive-grid-columns';
import style from '../style.module.less';
import ArchiveGridPlaceholder from './archive-placeholder';
import ArchiveGridErrorPlaceholder from './archive-error-placeholder';
import { ArchiveContext } from '../archive-context';

const ArchiveDetail = ({ archiveId }) => baseColumns.map((column) => <div key={column.id}>{column.render({ archiveId })}</div>);

ArchiveDetail.propTypes = {
  archiveId: PropTypes.string.isRequired,
};

const ArchiveGrid = () => {
  const { archiveIds, isLoading, hasError } = useContext(ArchiveContext);
  const isEmptyGrid = !isLoading && !archiveIds.length;

  return (
    <>
      {isEmptyGrid && !hasError && <ArchiveGridPlaceholder />}
      {hasError && <ArchiveGridErrorPlaceholder />}
      <div className={classnames(style['grid-container'], style['archive-grid-container'])}>
        {isLoading ? <GridLoading /> : archiveIds.map((archiveId, index) => <ArchiveDetail key={index} archiveId={archiveId} />)}
      </div>
    </>
  );
};

export default ArchiveGrid;
